// Formato numérico único para todo TechnoMath PR.
// Se usa coma como separador de miles: 1,675; 12,450; 1,000,000.
const wholeNumberFormat = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
});

export function formatWholeNumber(value) {
  const number = Number(value);
  return wholeNumberFormat.format(Number.isFinite(number) ? number : 0);
}

export function formatScore(value) {
  return formatWholeNumber(value);
}
